import { theme } from 'lib';
import styled from 'styled-components';

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${theme.SECONDARY};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  opacity: ${(props) => (props.visible ? '1' : '0')};
  pointer-events: ${(props) => (props.visible ? 'all' : 'none')};

  img {
    width: 300px;
    z-index: 112;
  }

  transition: opacity 0.8s;
`;

const SplashPage = ({ visible }) => {
  return (
    <Container visible={visible}>
      <img src={require('assets/branding/logo-white.png')} alt="" />
    </Container>
  );
};

export default SplashPage;
